import { AfterContentInit, Component, Input } from '@angular/core';
import { Product } from '../../../models/Product';
import { Router } from '@angular/router';

@Component({
  selector: 'ciu-product-description',
  templateUrl: './product-description.component.html',
  styleUrls: ['./product-description.component.css']
})
export class ProductDescriptionComponent implements AfterContentInit {

  constructor(private router: Router) {
  }

  @Input() product: Product;
  company_address;
  description;

  ngAfterContentInit() {
    if (!this.product) {
      this.router.navigate(['/home'])
    } else {
      this.company_address = this.product.company_address ? this.product.company_address.split(',') : '';
      this.description = this.product.description ? this.product.description.split('\n') : '';
    }

    this.router.events.subscribe(() => {
      setTimeout(() => {
        // window.scrollTo(0, 0);
      });
    });

  }

}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/container/product-details/product-description/product-description.component.ts